interface AnimatedBackgroundProps {
  className?: string
}

/**
 * Renders animated grid background with gradient overlays for hero section
 * Uses CSS-based animations for optimal performance
 * Limits gradient layers to 2 radial gradients for performance
 */
export function AnimatedBackground({ className = '' }: AnimatedBackgroundProps) {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {/* Grid pattern - CSS-based, no images */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20" />
      
      {/* Radial gradient overlays - Limited to 2 layers for performance */}
      <div className="absolute inset-0 bg-radial-gradient-1" />
      <div className="absolute inset-0 bg-radial-gradient-2" />
      
      {/* Animated gradient orbs - Using CSS gradients with GPU-accelerated transforms */}
      <div 
        className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse-slow" 
        style={{ 
          background: 'radial-gradient(circle, rgba(124, 140, 255, 0.1) 0%, transparent 70%)',
          transform: 'translateZ(0)' // GPU acceleration
        }}
      />
      <div 
        className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse-slow" 
        style={{ 
          background: 'radial-gradient(circle, rgba(93, 228, 199, 0.1) 0%, transparent 70%)',
          animationDelay: '1.5s',
          transform: 'translateZ(0)' // GPU acceleration
        }} 
      />
    </div>
  )
}
